import _ from "lodash";
import api from "@/api";
import projectFilterPresets from "./projectFilterPresets";

const initialState = () => ({
  filters: {
    term: "",
    accounts: null,
    is_archived: null,
    recently_updated_first: null,
    with_wet_stamp: null,
    type: null,
    exclude_type_combinations: null,
    states: null,
    client_po: null,
    status: null,
    claimed: null,
    engineer_id: null,
    quality_control_id: null,
    account_id: null,
    created_by: null,
    created_at: null,
    created_at_start_date: null,
    created_at_end_date: null,
    archived_at: null,
    archived_at_start_date: null,
    archived_at_end_date: null,
    show_archived: false,
    show_recently_updated_first: false,
    per_page: 15
  },
  projects_meta: {},
  projects_data: [],
  sort: {
    // by: "created_at",
    // desc: true
  },
  request_sequence: 0
});

export default {
  namespaced: true,
  state: initialState,
  getters: {},
  mutations: {
    SET_INITIAL_STATE: state => Object.assign(state, initialState()),
    SET_FILTERS: (state, payload) => {
      for (const key in payload) {
        state.filters[key] = payload[key];
      }
    },
    SET_PROJECT_DATA: (state, payload) => {
      state.projects_data = payload.data;
      state.projects_meta = payload.meta;
    },
    SET_SORTER: (state, payload) => (state.sort = payload),
    INCREMENT_REQUEST_SEQUENCE: state => (state.request_sequence += 1)
  },
  actions: {
    getData: async ({ state, commit }, page) => {
      commit("INCREMENT_REQUEST_SEQUENCE");
      const sequence = state.request_sequence;

      const params = {
        ...state.filters,
        page
      };

      const project = await api.get(`/projects`, { params });

      if (sequence !== state.request_sequence) {
        return null;
      }

      let data = _.get(project, "data.result", []);
      commit("SET_PROJECT_DATA", data);

      return project;
    }
  },
  modules: {
    projectFilterPresets
  }
};
